import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  standalone: false,
})
export class CustomSnackbarComponent {
  type: 'error' | 'warning' | 'success' | 'info' = 'success';

  constructor(
    public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      message: string;
      fontSize: string;
      iconSize: string;
    },
    @Inject(DOCUMENT) public document: Document,
  ) {}

  ngAfterViewInit() {
    const classType = this.document.getElementsByClassName(
      'mat-mdc-snack-bar-container',
    )[0].className;
    const typeName = classType.split(
      'mdc-snackbar mat-mdc-snack-bar-container snackbar-',
    )[1];
    this.type = typeName as 'error' | 'warning' | 'success' | 'info';
    this.document
      .getElementById(`message`)
      ?.style.setProperty('font-size', this.data.fontSize);
    const icon = this.document.getElementById(`${this.type}-icon`);
    icon?.style.setProperty('height', this.data.iconSize);
    icon?.style.setProperty('width', this.data.iconSize);
  }
}
